// Author YuJiaBei
// Date 2020-07-23 17:20:18

class EmActProcessDefinitionRegister {
constructor({
        id = null,
        name = '',
        code = '',
        definitionKey = '',
        businessEntity = '',
        planEntity = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.definitionKey = definitionKey;
    this.businessEntity = businessEntity;
    this.planEntity = planEntity;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new EmActProcessDefinitionRegister();
}

function gridFields() {
return Object.freeze([
        {
        key: 'name',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'definitionKey',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.grid.definitionKey',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'businessEntity',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.grid.businessEntity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planEntity',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.grid.planEntity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '启用' },
                            { value: '2', text: '冻结' },
                            { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.grid.remark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    nameFilter : "",
    codeFilter : "",
    definitionKeyFilter : "",
    businessEntityFilter : "",
    planEntityFilter : "",
    statusFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'definitionKeyFilter',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.filter.definitionKey',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'businessEntityFilter',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.filter.businessEntity',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'planEntityFilter',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.filter.planEntity',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' },
                { value: '3', text: '删除' }
            ]
        }
        }
];

const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'definitionKey',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.entity.definitionKey',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'businessEntity',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.entity.businessEntity',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'planEntity',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.entity.planEntity',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'status',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' },
                { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.workflow.emActProcessDefinitionRegister.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmActProcessDefinitionRegister, newEntity, gridFields, fields, filterFields, filter, filterConfigs, entityFormConfigs}
